export default "__VITE_ASSET__0e4dec39__"